import { BaseDAO } from './baseDAO';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Role } from 'anchor-shared/lib/model/entity/role';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class RoleDAO extends BaseDAO<Role> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.ROLE);
  }

  public getAllRolesNotAssociatedToUserId(userId: number): Observable<Role[]> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/admin/user-roles-not-associated-to-user?userId=' +
      userId;
    let method = 'GET';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall(url, method, null, null, headers);
  }

  public createRole(role: any, permissionIds: number[]): Observable<Role> {
    let url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/';
    let method: string = 'POST';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    let roleData = role as any;
    roleData.permissions = permissionIds;
    let data: Object = roleData;

    let httpRequest = this.apiHelper.apiCall(url, method, null, data, headers);

    let _roleDAO = this;
    return Observable.create(function subscribe(observer) {
      httpRequest.subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        },
      );
    });
  }

  public updateRole(role: Role, permissionIds: number[]): Observable<Role> {
    let url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/' + role.id;
    let method: string = 'PUT';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    let data = role;
    data['permissions'] = permissionIds;

    let httpRequest = this.apiHelper.apiCall(
      url,
      method,
      null,
      data,
      headers,
      null,
    );

    return Observable.create(function subscribe(observer) {
      httpRequest.subscribe(
        (data) => {
          observer.next(data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        },
      );
    });
  }

  public adminSession(): Observable<any> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/admin/session';
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any[]>(url, method, null, null, headers);
  }

  public getRolesWithPermissions(): Observable<Role[]> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/admin/roles-with-permissions';
    let method = 'GET';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall(url, method, null, null, headers);
  }

  public getRolesForUser(userId: number): Observable<Role[]> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/admin/user-roles?userId=' +
      userId;
    let method = 'GET';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall(url, method, null, null, headers);
  }
}
